import React from 'react';
import { Label, Paragraph } from 'atoms/Texts'
import { FormPass } from 'atoms/Inputs'
import { ButtonReg } from 'atoms/Buttons'
import { PassRow, ConfirmPassRow, BtnRow, WarningRow } from './styles'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'

const PassResetForm = props => {
  const {
    fnOnChange,
    fnOnSubmit,
    btnLabel,
    isBtnDisabled,
    isShowForm,
    isWarning,
    msg,
    theme,
    history: { push },
    match: { path }
  } = props

  const navToLogin = () => {
    const pathway = path.split('resetPassword')[0]
    push(`${pathway}`)
  }

  return (
    <div>
      {isShowForm ?
        <form onSubmit={fnOnSubmit}>
          <PassRow>
            <Label mb={'12px'}>
              New Password
            </Label>
            <FormPass onChangeVal={e => fnOnChange(e.target.value, 'password')} />
          </PassRow>
          <ConfirmPassRow>
            <Label mb={'12px'}>
              Confirm New Password
            </Label>
            <FormPass onChangeVal={e => fnOnChange(e.target.value, 'passwordConfirm')} />
          </ConfirmPassRow>
          <BtnRow>
            <ButtonReg
              btnTxt={btnLabel}
              disabled={isBtnDisabled}
              onClick={fnOnSubmit}
              btnType={'submit'}
            />
          </BtnRow>
          {isWarning &&
            <WarningRow>
              <Label size={'12px'} weight={'400'} color={theme.mocaRed}>
                {msg}
              </Label>
            </WarningRow>
          }
        </form> :
        <div style={{ marginTop: '32px' }}>
          <Paragraph size={'14px'}>{msg}</Paragraph>
          <BtnRow>
            <ButtonReg
              btnTxt={'Back to log in'}
              onClick={navToLogin}
              btnType={'button'}
            />
          </BtnRow>
        </div>
      }
    </div>
  )
}

export default withRouter(
  withTheme(PassResetForm)
)

